<template>
    <div>
        <div class="head">
          <van-tabs  v-model="activeName" line-width="50px" @click="onClick">
            <van-tab title="直播课" name='0'>
                      <seating></seating>
            </van-tab>
            <van-tab title="精品课" name='3'>
                      <seating></seating>
            </van-tab>
          </van-tabs> 
        </div>

        <div class="zhibo">
          <coursezhibo></coursezhibo>
        </div>
    </div> 
</template>

<script>
import seating from '@/components/seating' 
import coursezhibo from '@/components/CourseZhibo' 
import Vue from 'vue';
import { Tab, Tabs } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);

import VueEvent from '../model/VueEvent';
import URL from '../api/index'
export default {
    components:{
        seating,
        coursezhibo
    },
    data() {
        return {
            activeName: 'a',
    }
    },
    mounted(){

    },
    methods:{
        onClick(name, title) {
            VueEvent.$emit('tab',name)
        }
    }
}
</script>

<style scoped>
.van-tabs .van-tabs__wrap {
  height: 36px;
  margin-right: 70px;
  background-color: #fff;
}
.van-tabs /deep/ .van-tabs__line {
  background-color: #3296fa;
  height: 2px;
}
.van-tabs /deep/ .van-dropdown-menu__item{
    text-align: center;
}
.head{
  width: 100%;
  line-height: 45px;
  text-align: center;
  font-size: 14px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  background-color: #fff;
}
.zhibo{
  margin: 100px auto 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/tabsLive.vue